import React, { FC } from 'react';
import { createUseStyles } from '../theming';
import clsx from 'clsx';
import ComponentWithLabel from './ComponentWithLabel';

interface Props {
  label: string;
  text: string;
  className?: any;
  style?: any;
}

const useStyles = createUseStyles({
  root: {},
  text: {
    fontWeight: 400,
    color: 'black',
  },
});

const TextWithLabel: FC<Props> = ({ label, text, className, style }) => {
  const classes = useStyles();

  return (
    <ComponentWithLabel className={clsx(classes.root, className)} style={style} label={label}>
      <div className={classes.text}>{text}</div>
    </ComponentWithLabel>
  );
};

export default TextWithLabel;
